"use strict";
function initConfig(app) {
    app.config(function ($analyticsProvider, $httpProvider) {
        $analyticsProvider.virtualPageviews(false);
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push(function ($q, ORIGIN) {
            return {
                "request": function (config) {
                    if (/^\//.test(config.url)) {
                        config.url = "" + ORIGIN + config.url;
                    }
                    return config;
                }
            };
        });
    });
}
exports.initConfig = initConfig;



/** WEBPACK FOOTER **
 ** ./app/app.config.ts
 **/